import { render, staticRenderFns } from "./MessagesView.vue?vue&type=template&id=0aef49a4"
import script from "./MessagesView.vue?vue&type=script&lang=js"
export * from "./MessagesView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_css-load_d49922f226348ede918ce6b4a43f88e2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports